import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {BehaviorSubject, combineLatest, of} from "rxjs";
import {delay, map, take} from "rxjs/operators";
import {isBoolean} from "@app/core/shared/domain/type.utils";

export type buttonSize = 'small' | 'large'

@Component({
  selector: 'custom-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnChanges {
  @Input() disabled = false;

  @Input() type: 'submit' | 'button' | 'reset' = 'button';

  @Input() appearance: 'flat' | 'ghost' | 'text' = 'flat';

  @Input() color: 'default' | 'inverted' = 'default';

  @Input() expand: 'full' | 'block' = 'block';

  @Input() size: buttonSize = 'small';

  @Output() onClick = new EventEmitter();

  @Input() isLoading: boolean = false;
  private isLoadingSubject = new BehaviorSubject<boolean>(false)
  isLoading$ = this.isLoadingSubject.asObservable();

  ngOnChanges(changes: SimpleChanges): void {
    this.isLoadingSubject.next(this.isLoading);
  }
}

@Component({
  selector: '[customButton]',
  templateUrl: './button-converter.component.html',
  styleUrls: ['./button.component.scss'],
  host: {
    'class': 'button',
    '[class]': `[
      'button--' + appearance,
      'button--' + size,
      'button--' + color,
      'button--' + expand,
    ]`,
    '[class.button--loading]': 'isLoading',
  },
  inputs: ['appearance', 'expand', 'size', 'isLoading'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonConverterComponent implements OnChanges {

  @Input() type: 'submit' | 'button' | 'reset' = 'button';

  @Input() appearance: 'flat' | 'ghost' | 'text' = 'flat';

  @Input() color: 'default' | 'inverted' = 'default';

  @Input() expand: 'full' | 'block' = 'block';

  @Input() size: 'small' | 'large' | 'tiny' = 'small';

  @Input() isLoading?: boolean | null = false;
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  readonly isLoading$ = this.isLoadingSubject.asObservable();

  @Input() isSuccessful: boolean | null = false;
  private isSuccessfulSubject = new BehaviorSubject<boolean>(false);
  readonly isSuccessful$ = this.isSuccessfulSubject.asObservable();

  readonly canDisplayLoadingSpinner$ = this.isLoading$;
  readonly canDisplaySuccessIcon$ = combineLatest([
    this.canDisplayLoadingSpinner$,
    this.isSuccessful$
  ]).pipe(
    map(([canDisplayLoadingSpinner, isSuccessful]) =>
      !canDisplayLoadingSpinner && isSuccessful)
  );
  readonly canDisplayContent$ = combineLatest([
    this.canDisplayLoadingSpinner$,
    this.canDisplaySuccessIcon$,
  ]).pipe(
    map(([canDisplayLoadingSpinner, canDisplaySuccessIcon]) =>
      !(canDisplayLoadingSpinner || canDisplaySuccessIcon)
    )
  )

  ngOnChanges(changes: SimpleChanges): void {
    if (isBoolean(this.isLoading)) {
      this.isLoadingSubject.next(this.isLoading as boolean);
    }
    if (this.isSuccessful) {
      this.isSuccessfulSubject.next(true);
      of(false).pipe(
        delay(1000),
        take(1)
      ).subscribe({
        next: () => {
          this.isSuccessfulSubject.next(false)
        }
      });
    }
  }

}
